import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BotonTipo } from '../../../components/boton/boton';
import { MatDialog } from '@angular/material';
import { EstadoUsuarioDialog } from './estado-usuario-dialog/estado-usuario-dialog.component';
import { AuthenticationService } from '../../../providers/auth.service';

@Component({
  selector: 'app-estado-usuario',
  templateUrl: './estado-usuario.component.html',
  styleUrls: ['./estado-usuario.component.scss']
})
export class EstadoUsuarioComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() IdUsuario?: number | string;
  @Input() estado?: boolean;
  @Input() disabled: boolean = false;
  @Input() eliminable: boolean = false;
  @Input() tooltipDir: string = 'below';
  @Output() onCerrado = new EventEmitter();

  constructor(
    public dialog: MatDialog,
    public authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
    if (!this.IdUsuario) {
      throw "La variable Input 'IdUsuario' es requerida";
    }
    if (!this.estado) {
      throw "La variable Input 'estado' es requerida";
    }
  }

  openDialog(): void {
    let dialogEditar = this.dialog.open(EstadoUsuarioDialog, {
      disableClose: true,
      data: {
        IdUsuario: this.IdUsuario
      }
    });

    dialogEditar.afterClosed().subscribe(
      () => {
        this.onCerrado.emit();
      }
    );
  }
}
